<template>
  <div
    class="dummy"
    v-loading="true"
    element-loading-text="ログイン処理中...">
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'TokenLogin',
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions({
      tokenLogin: 'account/tokenLogin',
    }),
  },
  mounted () {
    console.log('ログイン処理')
    console.log(this.tokenLogin)
    this.tokenLogin(this.token).then(() => {
      console.log('ok')
      this.$router.push({name: 'Home'})
    }, err => {
      console.log(err)
      this.$message('ログイン処理に失敗しました')
      this.$router.push({name: 'Login'})
    })
  },
}
</script>

<style scoped>
.dummy {
  height: 100%;
  width: 100%;
  margin: auto;
  vertical-align: middle;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/TokenLogin.vue